import './customLegend.scss'
import { memo } from 'react'
import { isEqual } from 'lodash'
import { NiceChannelBox } from '@/features/analytics/components/nice-channel-box'
import { parseTelegramPeerReference } from '@synapex/shared2/telegram'

interface CustomLegendProps {
    payload?: any[]
    channelId: number
}

export const CustomLegendComponent = ({
    payload,
    channelId,
}: CustomLegendProps) => {
    if (!payload || payload.length === 0) return null

    return (
        <div className="custom-legend">
            {payload.map((entry, index) => {
                const { color, value, title } = entry
                const channelRef = value
                    ? parseTelegramPeerReference(value)
                    : null

                return (
                    <div key={`item-${index}`} className="custom-legend__item">
                        <span
                            className="custom-legend__color-circle"
                            style={{ backgroundColor: color }}
                        ></span>
                        {channelRef ? (
                            <NiceChannelBox
                                {...channelRef}
                                title={title}
                                channelId={channelId}
                                className="custom-legend__channel-box"
                            />
                        ) : (
                            <span className="custom-legend__text">{value}</span>
                        )}
                    </div>
                )
            })}
        </div>
    )
}

export const CustomLegend = memo(
    CustomLegendComponent,
    (prevProps, nextProps) =>
        isEqual(prevProps.payload, nextProps.payload) &&
        prevProps.channelId === nextProps.channelId
)
